module.exports = __webpack_public_path__ + "img/img_sub_comp_vision01.a5d73137.svg";